export type AmountKeySegment = 'single' | 'multiple';

export const toAmountKeySegment = (amount: number): AmountKeySegment => (amount === 1 ? 'single' : 'multiple');
